import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Cookies from 'js-cookie'
import { STORAGE_KEYS } from "@/constants/StorageKeys";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('@/layouts/DashboardLayout.vue'),
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('../views/home/AdminHomeView.vue')
      },
      {
        path: '/admin/users',
        name: 'admin.users',
        component: () => import('@/views/admin/AdminUsersView.vue')
      },
      {
        path: '/admin/products',
        name: 'admin.products',
        component: () => import('@/views/admin/AdminProductsView.vue')
      },
      {
        path: '/admin/sales',
        name: 'admin.sales',
        component: () => import('@/views/admin/AdminSalesView.vue')
      },
      {
        path: '/admin/payment-fees',
        name: 'admin.payment-fees',
        component: () => import('@/views/admin/PaymentFeesView.vue')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/auth/LoginView.vue'),
    name: 'login'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const publicRoutes = ['login']
  const token = Cookies.get(STORAGE_KEYS.TOKEN)

  if (publicRoutes.includes(to.name as string)) {
    next()
    return
  }

  if (!token) {
    next({ name: 'login' })
    return
  }

  next()
})

export default router
